var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"father",attrs:{"id":"app"}},[_c('el-carousel',{staticStyle:{"height":"100%"},attrs:{"interval":10000,"autoplay":true,"indicator-position":"none"}},_vm._l((_vm.pages),function(page){return _c('el-carousel-item',{key:page.name},[_c('KeepAlive',[_c(page.component,{tag:"component"})],1)],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }